import { useEffect, useRef } from "react";
import axios, { API } from "../api";
import { useAuth } from "../contexts/AuthContext";

export function AuthCallback({ onComplete }) {
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);

      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          await axios.post(`${API}/auth/google/session`, { session_id: sessionId });
          window.history.replaceState(null, '', window.location.pathname);
          await refreshUser();
          onComplete();
        } catch (error) {
          console.error('Auth callback failed:', error);
          window.history.replaceState(null, '', window.location.pathname);
          onComplete();
        }
      } else {
        onComplete();
      }
    };

    processSession();
  }, []);

  return (
    <div className="app-container">
      <div className="wallpaper-placeholder">
        <h1>✨</h1>
        <p>Connecting your account...</p>
      </div>
    </div>
  );
}
